import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconTriangleDownComponent } from "./med-icon-triangle-down.component";

@NgModule({
  declarations: [
    MedIconTriangleDownComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconTriangleDownComponent,
  ],
})
export class MedIconTriangleDownModule { }
